<template>

    <aside class="popup-accordion">
        <div
                class="popup"
                v-if="$root.states.popupAccordionData"
        >
            <div class="accordion-menu">
                <template v-for="(listItem, listItemIndex) in $root.states.popupAccordionData['content_list_repeater']">
                    <template v-for="(listContent, listContentIndex) in listItem['list_content_composer']">
                        <div
                                class="accordion-menu-item"
                                v-if="listContent['acf_fc_layout'] === 'list_content_composer_subline_h2'"
                                v-on:click="scrollToAccordionIndex(listItemIndex, listContentIndex)"
                        >
                            {{ listContent['list_content_subline_h2'] }}
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </aside>

</template>

<script>

    // console.log('PopupAccordion');

    export default {
        created(){
            window.addEventListener('keyup', this.onKeyEscape);
        },
        destroyed(){
            window.removeEventListener('keyup', this.onKeyEscape);
        },
        components : {},
        methods : {
            cancelPopup(){
                this.$root.states.popupAccordionData = null;
                this.$root.states.popupAccordionId = null;
            },
            scrollToAccordionIndex(listItemIndex, listContentIndex){
                this.$root.events.$emit('popupAccordionSelect', this.$root.states.popupAccordionId, listItemIndex, listContentIndex);
                this.$root.states.popupAccordionData = null;
                this.$root.states.popupAccordionId = null;
            },
            onKeyEscape(event){
                if (event.key === 'Escape') {
                    this.cancelPopup();
                }
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .popup-accordion {
        z-index: 2000;
        .popup {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100vh;
            padding: 2rem;
            background-color: transparentize($color-nochvielvor-pink-light, 0.04);
            @media screen and (max-width: 767px) {
                padding: 1.5rem;
            }
            @media screen and (min-width: 1200px) {
                padding: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding: 2rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding: 2rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding: 2rem * $factor-2400;
            }
        }
        .accordion-menu {
            max-width: 38rem;
            @media screen and (min-width: 1200px) {
                max-width: 38rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                max-width: 38rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                max-width: 38rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                max-width: 38rem * $factor-2400;
            }
            .accordion-menu-item {
                position: relative;
                padding: 1rem 0;
                color: $color-nochvielvor-white;
                cursor: pointer;
                font-size: 1.25rem;
                font-weight: bold;
                border-bottom: 1px solid $color-nochvielvor-white;
                @media screen and (max-width: 767px) {
                    font-size: 1.25rem * $factor-720;
                    padding: 1rem * $factor-720 0;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 1.25rem * $factor-1200;
                    padding: 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1.25rem * $factor-1440;
                    padding: 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1.25rem * $factor-1920;
                    padding: 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1.25rem * $factor-2400;
                    padding: 1rem * $factor-2400 0;
                }
                &:first-child {
                    &:before {
                        content: '';
                        position: absolute;
                        left: -1.6875rem - 1rem;
                        top: 0;
                        width: 1.6875rem;
                        height: 100%;
                        background-image: url(/img/ic_accordion_ffffff.svg);
                        background-position: 0 50%;
                        background-repeat: no-repeat;
                        background-size: 1.6875rem 1.5625rem;
                        @media screen and (max-width: 767px) {
                            display: none;
                        }
                        @media screen and (min-width: 1200px) {
                            left: (-1.6875rem - 1rem) * $factor-1200;
                            width: 1.6875rem * $factor-1200;
                            background-size: 1.6875rem * $factor-1200 1.5625rem * $factor-1200;
                        }
                        @media screen and (min-width: 1440px) {
                            left: (-1.6875rem - 1rem) * $factor-1440;
                            width: 1.6875rem * $factor-1440;
                            background-size: 1.6875rem * $factor-1440 1.5625rem * $factor-1440;
                        }
                        @media screen and (min-width: 1920px) {
                            left: (-1.6875rem - 1rem) * $factor-1920;
                            width: 1.6875rem * $factor-1920;
                            background-size: 1.6875rem * $factor-1920 1.5625rem * $factor-1920;
                        }
                        @media screen and (min-width: 2400px) {
                            left: (-1.6875rem - 1rem) * $factor-2400;
                            width: 1.6875rem * $factor-2400;
                            background-size: 1.6875rem * $factor-2400 1.5625rem * $factor-2400;
                        }
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// public/js/components/PopupAccordion.vue